export const getConnectionConfigReq = ({domain, phone}) => ({
  path: `v1/prefs/${domain}`,
  params: {t: 'get_user_phone', phone}
});

export const getPipelineListReq = domain => ({
  path: `v1/prefs/${domain}`,
  params: {t: 'pipelines'}
});

export const getManagerListReq = domain => ({
  path: `v1/prefs/${domain}`,
  params: {t: 'managers'}
});

export const updateConnectionConfigReq = ({domain, phone, data}) => ({
  path: `v1/prefs/${domain}`,
  params: {t: 'set_pref', phone},
  method: 'post',
  data
});

export const updateEmployeeListReq = domain => ({
  path: `v1/prefs/${domain}`,
  params: {t: 'update'}
});
